import { useState } from 'react';
import img1 from './Image/photo-poster-ai-1.png'
import img2 from './Image/photo-poster-ai-2.png'
import img3 from './Image/photo-poster-ai-3.png'
import './index.css';

const data = [
    {
        title: 'Pringles.',
        aspectRatio: '1:1',
        picture: img1,
    },
    {
        title: 'Gokul Santol',
        aspectRatio: '16:9',
        picture: img2,
    },
    {
        title: 'Gaming Controller',
        aspectRatio: '9:16',
        picture: img3,
    },

]

const ContentPhotoPosterAi = () => {
    const [selectedImage, setSelectedImage] = useState(null);

    return (
        <div className='text-white'>
            {
                data.map((item, index) => <div className='mb-5' key={index}>
                    <p className='fw-bold text-center'>{item.title}</p>
                    <p className='text-center'><span className='fw-bold'>Aspect Ratio:</span> {item.aspectRatio}</p>
                    <img
                        className='imgeAI-image d-flex gap-2 flex-column justify-content-center align-items-center mx-auto'
                        src={item.picture}
                        alt={item.title}
                        onClick={(e) => {
                            e.stopPropagation();
                            setSelectedImage(item.picture);
                        }}
                        style={{
                            cursor: "pointer",
                            transition: "transform 0.2s",
                        }}
                        onMouseEnter={(e) => e.target.style.transform = "scale(1.02)"}
                        onMouseLeave={(e) => e.target.style.transform = "scale(1)"}
                    />
                </div>)
            }

            {/* Lightbox Modal */}
            {selectedImage && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        background: "rgba(0,0,0,0.85)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 9999,
                        cursor: "pointer",
                    }}
                    onClick={() => setSelectedImage(null)}
                >
                    <img
                        src={selectedImage}
                        alt="Preview"
                        style={{
                            maxWidth: "90vw",
                            maxHeight: "90vh",
                            borderRadius: "12px",
                            boxShadow: "0 10px 40px rgba(0,0,0,0.5)",
                        }}
                        onClick={(e) => e.stopPropagation()}
                    />
                    <div
                        style={{
                            position: "absolute",
                            top: "20px",
                            right: "30px",
                            color: "#fff",
                            fontSize: "30px",
                            cursor: "pointer",
                        }}
                        onClick={() => setSelectedImage(null)}
                    >
                        ✕
                    </div>
                </div>
            )}
        </div>
    );
};

export default ContentPhotoPosterAi;